import Shipping from "./Shipping.view";

export default Shipping;
